export default {
  common: {
    keywordSearch: "输入要搜索的关键字",
    actions: "操作",
    add: "添加",
    edit: "编辑",
    view: "查看",
    tag: "标签",
    collapseMenu: "折叠菜单",
    save: "保存",
    cancel: "取消",
    delete: "删除",
    deleteConfirmMsg: "您确定要删除吗?",
    no: "不是",
    yes: "是",
    noDataAvailable: "无数据",
    reason: "原因",
    createdBy: "创建者",
    modifiedBy: "修改者",
    saveChanges: "保存更改",
    close: "关闭",
    pleaseEnter: "请输入...",
    globalSmartSearch: "全局搜索...",
    loadingText: "我们正在为你加载数据. 请稍等.",
    collapse: "折叠",
    expand: "展开",
    search: '搜索',
    paracetamol: '扑热息痛',
    disable: '禁用',
    downloadPDF: "PDF下载"
  },
  appLauncher: {
    admin: {
      title: "用户管理",
      subTitle: "您可以管理用户",
    },
    tenant: {
      title: "租户管理",
      subTitle: "你可以管理你的租户",
    },
  },
  date: {
    receivedDate: "接收日期",
    dueDate: "到期日",
    responseDate: "响应日期",
    binderApprovalDate: "批准日期",
    createdDate: "创建日期",
    modifiedDate: "修改日期",
  },
  menu: {
    dashboards: "仪表盘",
    products: "产品",
    rtqs: "RTQs",
    components: "组件",
    component_contents: "组件内容",
    settings: "设置",
    document_types: "文件类型",
    document_records: "文件记录",
    published_documents: "发表文件",
    pinned: "已固定",
    recent: "最近的",
    searchModule: "搜索模块",
    aiAssistant: "AI助手",
    modules: '模块'
  },
  domain: {
    label: "领域",
    pluralLabel: "领域",
    medicalProduct: "医疗产品",
    medicalDevices: "医疗器械",
    foodAndSupplements: "食物和补充剂",
    consumer: "消费者",
  },
  tool: {
    summarizer: "摘录者",
    translator: "翻译家",
  },
  aiAssistant: {
    title: "嘿 <b>Suren</b>! 我是你的聊天 <b>助手</b>!",
    subTitle: "问我任何与rim有关的问题，我会尽量了解细节。",
    placeholder: '在这里键入询问雷吉。'
  },
  product: {
    products: "产品",
    addProduct: "添加产品",
    productName: "产品名称",
    productType: "产品类型",
    productNameTooltip: "产品的名字",
    productTypeTooltip: "产品的类型",
    productFamilyCodeTooltip: "产品代码: OG-xxxx",
    productFamilyCode: "产品代码",
    activeIngredientSubstance: "活性成分/物质",
    strength: "浓度",
    strengthUnit: "浓度单位",
    dosageForm: "剂型",
    basicInformation: "基础信息",
    routeOfAdmin: "管理途径",
    tradeName: "商标名称",
    genericNameOrFamilyName: "通用名/系列名",
    productStatus: "产品状态",
    therapeuticArea: "治疗领域",
    countryGroup: "国家分组",
    country: "国家",
    pack: '包装',
    shelfLife: '货架期',
    storageCondition: '储存条件',
    category: "产品类别",
    type: "产品类型",
    subcategory: "产品子类别",
    name: "产品名称",
    birthdate: "国际生产日期",
    businessunit: "业务部门",
    studyNumber: "研究编号",
    studyDescription: "研究描述",
    studyApprovalDate: "研究批准日期",
    productsDes: "产品信息",
    showActive: '展示激活',
    showInactive: '展示未激活',
    showDisabled: '展示禁用',
    reasonForDisable: '禁用的原因',
    comment: '评论',
    disableProduct: "禁用产品",
    disableProductTitle: '你确定想要使这个产品禁用吗',
    disableProductSuccessTip: '禁用这条记录成功',
    comments: "评论",
    deleteSubstanceSuccessTip: '活性成分/物质删除成功.',
    createSubstanceSuccessTip: '活性成分/物质创建成功.',
    updateSubstanceSuccessTip: '活性成分/物质更新成功.',
    updateTradeSuccessTip: '商标名称更新成功.',
    deleteTradeSuccessTip: '商标名称删除成功.',
    createTradeSuccessTip: '商标名称创建成功.',
    updateRouteSuccessTip: '管理途径更新成功.',
    deleteRouteSuccessTip: '管理途径删除成功.',
    createRouteSuccessTip: '管理途径创建成功.',
    recordExistsTip: '记录已经存在.重新输入一条不一样的记录.',
    updateProductSuccessTip: '产品更新成功.',
    createProductSuccessTip: '产品创建成功.',
    reasonForInactive: '不活动的原因',
  },
  rtq: {
    addRtq: "添加RTQ",
    title: "标题",
    category: "分类",
    healthAuthority: "卫生局",
    query: {
      label: "问题",
      pluralLabel: "问题",
      queryStatus: "问题状态",
      queryTopicTitle: "查询主题/标题",
    },
    tab: {
      basicInformation: "基础信息",
      basicInformationDes: "提供产品基本信息",
      questionResponseDetails: "问题和回答细节",
      questionResponseDetailsDes: "问题及回答细节",
      products: "产品",
      productsDes: "产品信息",
      submissions: "提交",
      submissionsDes: "提交信息",
      categories: "类别",
      categoriesDes: "选择适用的类别",
      documents: "文档",
      documentsDes: "上传与查询相关的文档",
      workflow: "工作流",
      workflowDes: "参见工作流和查询状态",
    },
    submission: {
      label: "提交",
      pluralLabel: "意见书",
      submissionType: "提交类型",
      procedureType: "程序类型",
      applicationNumber: "申请编号",
      mANumber: "MA 数量",
      controlNumber: "控制号",
      comments: "评论",
    },
    question: {
      addQuestion: "添加问题",
      questionDescription: "问题描述",
      questionStatus: "问题状态",
      assignedTo: "分配给",
      comments: "评论",
    },
    response: {
      addResponse: "添加响应",
      editResponse: "编辑响应",
      responseDescription: "响应描述",
      department: "部门",
      responseStatus: "响应状态",
    },
    mentionsText: "在这里提到行动日期，并分配RTQ所有者",
    owner: "所有者",
  },
  filter: {
    apply: "应用",
    and: "至",
    clear: "清除",
    searchIntro: "你可以选择或反选来过滤内容.",
    selected: "已选择",
    more: "更多",
    identifiers: "过滤项",
    product: {
      label: "产品名称",
      totalLabel: "全部产品",
      searchPlaceholder: "检索产品",
    },
    markets: {
      label: "市场",
      totalLabel: "全部市场",
      searchPlaceholder: "检索市场",
    },
    country: {
      label: "国家",
      totalLabel: "全部国家",
      searchPlaceholder: "检索国家",
    },
    function: {
      label: "功能",
      totalLabel: "全部功能",
      searchPlaceholder: "检索功能",
    },
    rtq_date: {
      label: "日期",
      fromDatePlaceholder: "选择起始日期",
      toDatePlaceholder: "选择截止日期",
      lessThanPlaceholder: "选择最大日期",
      moreThanPlaceholder: "选择最小日期",
      lessThan: "日期小于",
      moreThan: "日期大于",
      between: "日期范围",
    },
    active_substance: {
      label: "活性物质",
      totalLabel: "全部活性物质",
      searchPlaceholder: "检索活性物质",
    },
    registration_no: {
      label: "注册号",
      totalLabel: "全部注册号",
      searchPlaceholder: "检索注册号",
    },
    device_id: {
      label: "设备号",
      totalLabel: "全部设备号",
      searchPlaceholder: "检索设备号",
    },
    device_name: {
      label: "设备名称",
      totalLabel: "全部设备名称",
      searchPlaceholder: "检索设备名称",
    },
    device_type: {
      label: "设备类型",
      totalLabel: "全部设备类型",
      searchPlaceholder: "检索设备类型",
    },
    document_type: {
      label: "文档定义",
      totalLabel: "全部文档定义",
      searchPlaceholder: "检索文档定义",
    },
    document_record: {
      label: "文档记录",
      totalLabel: "全部文档记录",
      searchPlaceholder: "检索文档记录",
    },
    document: {
      label: "文档",
      totalLabel: "全部文档",
      searchPlaceholder: "检索文档",
    },
    filterItems: {
      label: "过滤项",
      totalLabel: "全部过滤项",
      searchPlaceholder: "检索过滤项",
    },
    popup: {
      unSaveChanges: '改动并不报错',
      confirmUnSaveChanges: '您确定要离开此页面吗？任何未保存的更改都将丢失.'
    },
    audit: {
      entityIdentifier: '实体标识符',
      auditIdentifier: '审计标识符',
      entityName: '实体名称',
      entityCreatedDate: '创建日期和时间',
      entityModifiedDate: '修改日期和时间',
      fieldName: '字段名',
      beforeModification: '在修改之前',
      afterModification: '在修改之后',
      operationType: '操作类型',
      operationDate: '运营日期和时间',
      note: '注意:该表只包含在此事务期间更新的字段',
      audit: '审计'
    }
  },
};
